import React from "react";
import styled from "styled-components";
import { useCurrentFrame } from "../use-current-frame";
import { interpolate } from "../interpolate";
import { useVideoConfig } from "../use-video-config";

/* The typing effect */
// @keyframes typing {
//     from { width: 0 }
//     to { width: 100% }
//   }

const TypeWriter = styled.div``;

const Holder = styled.span`
    overflow: hidden; /* Ensures the content is not revealed until the animation */
    white-space: nowrap; /* Keeps the content on a single line */
    display: block;
    width: auto;
`;

function TypeWritingAnimation(props) {
    const frame = useCurrentFrame();
    const { fps } = useVideoConfig();
    const { children } = props;

    // Complete the typing in ~2 seconds (or use enterDuration if provided)
    const typeDuration = Math.round((props.enterDuration || 2) * (fps || 30));

    const width = interpolate(frame, [0, typeDuration], [0, 100], {
        extrapolateLeft: "clamp",
        extrapolateRight: "clamp",
    });

    return (
        <TypeWriter>
            <Holder style={{ width: `${Math.round(width)}%` }}>
                {children}
            </Holder>
        </TypeWriter>
    );
}

export default React.memo(TypeWritingAnimation);
